import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyBjB-43EpdOGsI6dUqTSDU9lvikdYizhRY",
    authDomain: "pauls-place.firebaseapp.com",
    projectId: "pauls-place",
    storageBucket: "pauls-place.appspot.com",
    messagingSenderId: "456824381068",
    appId: "1:456824381068:web:4da31a8ba83aaaf5b625a9"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  export default db;